import fp from 'lodash/fp';
import React, {
    useEffect,
    ComponentType,
} from 'react';
import { messaging } from '@factorin/container.macro';

import {
    Portal,
    TransitionComponent,
    TransitionGroup,
    animation,
    useMemoDeps,
} from 'Modules/ui';
import { Box } from 'Modules/ui3';

import { Notification } from '../Notification';
import {
    MessagingQueueTypes,
    ModalType,
    NotificationType,
} from '../../state/types';
import { useHideAction } from '../../state';
import { Modal } from '../Modal';


export const Messaging: ComponentType = () => {
    const { hideLastModal, queue } = useHideAction();
    useEffect(() => {
        const onKeyDown = e => {
            if (e.key === 'Escape')
                hideLastModal();
        };
        document.addEventListener('keydown', onKeyDown);
        return () => document.removeEventListener('keydown', onKeyDown);
    }, [hideLastModal]);

    const [modals, notifications] = useMemoDeps(fp.partition<MessagingQueueTypes>('isModal'), [
        queue,
    ]) as unknown as [ModalType[], NotificationType[]];
    return (
        <Portal>
            <Box position='fixed' top={2} right={0} zIndex={50}>
                <TransitionGroup>
                    {notifications.map((notification: NotificationType) => (
                        <TransitionComponent
                            key={notification.id}
                            timeout={animation * 2}
                        >
                            <Notification notification={notification} />
                        </TransitionComponent>
                    ))}
                </TransitionGroup>
            </Box>
            <TransitionGroup>
                {modals.map((modal: ModalType) => (
                    <TransitionComponent
                        key={modal.id}
                        timeout={messaging.modalTypes[modal.type]?.animation?.duration || animation}
                    >
                        <Modal modal={modal} />
                    </TransitionComponent>
                ))}
            </TransitionGroup>
        </Portal>
    );
};
